<template>
  <DialogWrapper
    close-on-cancel
    destroyOnClose
    class="offer-letter-content-dialog"
    :show.sync="isShow"
    :loading="loading"
    :titleI18nKey="`${i18nPrefix}.title.sendOfferLetter`"
  >
    <WrappedForm
      ref="offerLetterContentForm"
      class="offer-letter-info"
      label-width="160px"
      :model="offerLetterInfo"
      :formLines="formLines"
    >
      <template #companyListSlot>
        <el-input v-model="selectCompany" clearable class="company-select"></el-input>
      </template>
      <template #jobListSlot>
        <el-input v-model="selectJob" clearable class="job-select"></el-input>
      </template>
    </WrappedForm>
    <template #footer>
      <div class="dialog-footer">
        <el-button class="footer-btn cancel-btn" @click="handleClosed">{{ $t('common.btn.cancel') }}</el-button>
        <el-button class="footer-btn save-btn" @click="handlePreview">{{ $t('common.btn.preview') }}</el-button>
        <el-button class="footer-btn save-btn" @click="handleSendInviteOffer">{{ $t(`${i18nPrefix}.btn.sendOffer`) }}</el-button>
      </div>
    </template>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import { getI18nPropertyValue } from '@/i18n'
import { OFFER_LETTER_TEMPLATE_FIELD_TYPE } from '@/constant/company'
import mixin from '@/views/personalNew/offerLetter/mixin'

export default {
  mixins: [mixin],
  components: {
    DialogWrapper,
    WrappedForm
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    templateList: {
      type: Array,
      default: () => []
    },
    templateFieldList: {
      type: Array,
      default: () => []
    },
    selectedTemplateId: {
      required: true
    },
    candidateName: {
      type: String
    },
    candidateEmail: {
      type: String,
      default: ''
    },
    candidateFirstName: {
      type: String
    },
    candidateLastName: {
      type: String
    },
    companyName: {
      type: String
    },
    jobName: {
      type: String
    },
    companyId: {
      required: false
    },
    jobId: {
      required: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      loading: false,
      companyList: [],
      jobList: [],
      jobLoadMap: {},
      selectCompany: null,
      selectJob: null,
      offerLetterInfo: {
        candidateFullName: null,
        candidateEmail: null,
        candidateFirstName: null,
        candidateLastName: null,
        todayPlus0: null,
        companyName: null,
        jobTitle: null
      }
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    },
    formLines () {
      const lines = {}
      if (this.selectedTemplateId) {
        const template = _.find(this.templateList, { id: this.selectedTemplateId })
        if (!template) {
          return lines
        }
        const content = template.content
        const allKeys = this.getTemplateAllPlaceholder(content)
        const templateFields = _.chain(this.templateFieldList).filter(item => _.includes(allKeys, item.key)).map(item => {
          item.order = _.findIndex(allKeys, key => key === item.key)
          return item
        }).orderBy('order').value()
        _.forEach(templateFields, item => {
          const key = item.key
          const label = getI18nPropertyValue(item, 'name_cn', 'name_en')
          const lineProps = { clearable: true }
          const line = {
            label: label,
            elType: 'el-input',
            props: lineProps
          }
          const valueType = item.value_type
          if (key === 'companyName') {
            line.contentSlot = 'companyListSlot'
          } else if (key === 'jobTitle') {
            line.contentSlot = 'jobListSlot'
          } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.SELECT) {
            line.elType = 'el-select'
            lineProps.filterable = true
            lineProps.multiple = true
            line.option = {
              data: item.option_list,
              valueKey: 'id',
              labelKey: 'i18nName'
            }
          } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.SINGLE) {
            line.elType = 'el-select'
            lineProps.filterable = true
            lineProps.multiple = false
            line.option = {
              data: item.option_list,
              valueKey: 'id',
              labelKey: 'i18nName'
            }
          } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.TEXT) {

          } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.TEXTAREA) {
            lineProps.type = 'textarea'
            lineProps.autosize = { minRows: 3 }
          } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.DATE) {
            line.elType = 'el-date-picker'
          }
          lines[key] = line
        })
      }
      return lines
    }
  },
  created () {
  },
  methods: {
    async initPage () {
      this.loading = true
      try {
        const today = moment()
        this.offerLetterInfo.candidateFullName = this.candidateName
        this.offerLetterInfo.candidateEmail = this.candidateEmail || ''
        this.offerLetterInfo.candidateFirstName = this.candidateFirstName
        this.offerLetterInfo.candidateLastName = this.candidateLastName
        this.offerLetterInfo.todayPlus0 = today.toDate()
        if (this.companyId) {
          this.selectCompany = this.companyName
        }
        if (this.jobId) {
          this.selectJob = this.jobName
        }
      } finally {
        this.loading = false
      }
    },
    async handleSendInviteOffer () {
      if (!await this.$refs.offerLetterContentForm.submit()) {
        return
      }
      if (this.selectCompany) {
        this.offerLetterInfo.companyName = this.selectCompany
      }
      if (this.selectJob) {
        this.offerLetterInfo.jobTitle = this.selectJob
      }
      this.loading = true
      this.$emit('save', this.offerLetterInfo, () => {
        this.loading = false
      })
    },
    handleClosed () {
      this.$emit('cancel')
    },
    handlePreview () {
      if (this.selectCompany) {
        this.offerLetterInfo.companyName = this.selectCompany
      }
      if (this.selectJob) {
        this.offerLetterInfo.jobTitle = this.selectJob
      }
      this.$emit('preview', this.offerLetterInfo, this.selectedTemplateId)
    }
  },
  watch: {
    isShow () {
      if (this.isShow) {
        this.initPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.offer-letter-content-dialog {
  ::v-deep {
    .el-dialog {
      width: 40%;
    }
  }

  .offer-letter-info {
  }

  .dialog-footer {
    .footer-btn  {
      border-radius: 2px;
      padding: 10px 30px;
    }

    .save-btn {
      background: #0096cc;
      border-color: #0096cc;
      color: #ffffff;
    }

    .cancel-btn {
      background: #ffffff;
      color: #606266;
    }
  }
}

.job-select-popper {
  .el-select-dropdown__item {
    min-width: 100%;
    max-width: 24vw;
    overflow: hidden;
    word-break: keep-all;
    text-overflow: ellipsis;
  }
}
</style>
